import { render } from "./ShopService.vue?vue&type=template&id=21fd7330&scoped=true"
import script from "./ShopService.vue?vue&type=script&lang=js"
export * from "./ShopService.vue?vue&type=script&lang=js"

import "./ShopService.vue?vue&type=style&index=0&id=21fd7330&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/engineering/engineering/projects/jb-long-and-son-body-shop-website/code/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fd7330"]])

export default __exports__